enum FeatureKey {
  SearchShowsScore = 'search_shows_score',
  SpeechSynthesIsEnabled = 'enable_speech_synthesis',
}

export const InternalFeatures = [FeatureKey.SearchShowsScore];

export default FeatureKey;
